<template>
  <div class="data-list-container">
    <div
      :class="
        !$route.params.modelname
          ? 'vs-component con-vs-popup vs-popup-primary cstm-modal-popup show'
          : ''
      "
    >
      <div class="cstm-modal medium fixed_medium">
        <div class="header p-0" v-if="!$route.params.modelname">
          <button @click.stop="closePopup" class="close-modal">&times;</button>
        </div>
        <vs-card class="cstm_vx_card content_mb_0 mb-0">
          <div
            slot="header"
            class="flex flex-wrap justify-between items-center"
          >
            <h4>Dynamic Fields</h4>

            <vs-button
              @click="addSidebarEvent = !addSidebarEvent"
              color="primary"
            >
              Add New Dynamic Fields
            </vs-button>
          </div>
          <div
            style="max-height: calc(100vh - 300px); overflow-y: auto"
            class="table_responsive vertical_scrollbar"
          >
            <table class="cstm_vuexy_table w-full">
              <tbody>
                <tr
                  v-for="custom_field in custom_fields"
                  :key="custom_field.attribute_id"
                >
                  <td class="p-2">
                    <b class="text-primary">{{ custom_field.label }}</b>
                  </td>
                  <td class="p-2">
                    <b class="text-primary">{{ custom_field.inputtype }}</b>
                  </td>
                  <td class="p-2">
                    <vs-checkbox
                      v-model="custom_field.is_required"
                      :checked="custom_field.is_required"
                      :value="custom_field.is_required"
                      :disabled="true"
                      >Is Required</vs-checkbox
                    >
                  </td>
                  <td class="p-2">
                    <small>{{ custom_field.description }}</small>
                  </td>
                  <td class="p-2">
                    <vs-dropdown
                      style="cursor: pointer"
                      vs-custom-content
                      vs-trigger-click
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-more-vertical"
                      ></vs-button>

                      <vs-dropdown-menu>
                        <vs-dropdown-item
                          @click="editSidebar(custom_field.attribute_id)"
                        >
                          Edit</vs-dropdown-item
                        >
                        <vs-dropdown-item
                          @click="openConfirm(custom_field.attribute_id)"
                        >
                          Delete</vs-dropdown-item
                        >
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vs-card>
      </div>
      <div
        class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
        v-if="addSidebarEvent"
        :class="{ show: addSidebarEvent }"
      >
        <div class="cstm-modal medium fixed_medium">
          <div class="header">
            <h4>
              {{
                `Add Dynamic Field for ${
                  modulename == "Client" ? "Student" : modulename
                }`
              }}
            </h4>
            <button @click.stop="closeaddSidebarEvent" class="close-modal">
              &times;
            </button>
          </div>
          <div
            style="max-height: calc(100vh - 100px); overflow-y: auto"
            class="vertical_scrollbar p-4"
          >
            <add-sidebar-dynamic
              :isSidebarActive="addSidebarEvent"
              :entityModel="entityModel"
              @closeSidebarEvent="addDynamicSidebarEvent"
            />
          </div>
        </div>
      </div>
            <div
        class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
        v-if="editSidebarEvent"
        :class="{ show: editSidebarEvent }"
      >
        <div class="cstm-modal medium fixed_medium">
          <div class="header">
            <h4>
              {{
                `Edit Dynamic Fields for ${
          modulename == 'Client' ? 'Student' : modulename
        }`
              }}
            </h4>
            <button @click.stop="closeEditSidebarEvent" class="close-modal">
              &times;
            </button>
          </div>
          <div
            style="max-height: calc(100vh - 100px); overflow-y: auto"
            class="vertical_scrollbar p-4"
          >
           <edit-sidebar-dynamic
          v-if="editSidebarEvent"
          :isSidebarActive="editSidebarEvent"
          :entityModel="entityModel"
          @closeSidebarEditEvent="EditDynamicSidebarEvent"
          :editedData="editedAttribute"
        >
        </edit-sidebar-dynamic>
          </div>
        </div>
      </div>
    </div>
    <!-- {{custom_fields}} -->
  </div>
</template>
<script>
import { fetchCustomFields, deleteCustomField } from '@/api/customfield'
import vSelect from 'vue-select'
import AddSidebarDynamic from '@/components/common/add-sidebar-dynamic'
import EditSidebarDynamic from '@/components/common/edit-sidebar-dynamic'


export default {
  components: {
    vSelect,
    AddSidebarDynamic,
    EditSidebarDynamic
  },

  name: 'custom-value-list-module-view',
  data () {
    return {
      addSidebarEvent: false,
      editSidebarEvent: false,
      custom_fields: [],
      entityModel: '',
      modulename: this.$route.params.modelname
        ? this.$route.params.modelname
        : this.modelnamePass,
      editedAttribute: {},
      deleted_id: ''
    }
  },
  props: {
    modelnamePass: {
      default: ''
    }
  },
  mounted () {
    this.fetch_list()
  },

  methods: {
    closeEditSidebarEvent () {
      this.editSidebarEvent = false
    },
    closeaddSidebarEvent () {
      this.addSidebarEvent = false
    },
    closePopup () {
      this.$emit('closeDynamicModal', true)
    },
    editSidebar (attribute_id) {
      this.editedAttribute = this.custom_fields.find(
        (element) => element.attribute_id === attribute_id
      )
      this.editSidebarEvent = true
    },
    addDynamicSidebarEvent (obj) {
      if (obj === false) {
        this.addSidebarEvent = false
      } else {
        this.custom_fields.push(obj)

        this.addSidebarEvent = false
      }
    },

    EditDynamicSidebarEvent (obj) {
      if (obj === false) {
        this.editSidebarEvent = false
      } else {
        // this.custom_fields.push(obj)

        // this.custom_fields.findIndex()
        const index = this.custom_fields.findIndex(
          (element) => element.attribute_id === obj.attribute_id
        )
        this.custom_fields[index] = obj

        //

        this.editSidebarEvent = false
      }
    },
    checkingChanges (id) {
      //
      const index = this.custom_fields.findIndex(
        (element) => element.attribute_id === id
      )
      this.$set(this.custom_fields, index, {
        ...this.custom_fields[index],
        save: true
      })
    },
    editcolumns (id) {
      const index = this.custom_fields.findIndex(
        (element) => element.attribute_id === id
      )

      this.$set(this.custom_fields, index, {
        ...this.custom_fields[index],
        disable: false
      })
      //for making reactive beacuse of using array index

      // this.custom_fields[index].disable = false
      // this.custom_fields = this.custom_fields
    },

    async fetch_list () {
      //   this.$vs.loading()
      this.$vs.loading({ text: 'Fetching Dynamic Fields' })

      try {
        console.log(this.$route.params.modelname)
        let payload = this.$route.params.modelname
          ? this.$route.params.modelname
          : this.modelnamePass
        if (payload === 'Leads') {
          payload = 'Crm'
        }

        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomFields(payload, customerId)
        //

        this.custom_fields = data.data.custom_fields

        console.log(this.custom_fields)

        this.entityModel = data.data.entitymodels

        //

        // this.custom_fields.forEach(function (element) {
        //   element.disable = true
        //   element.save = false
        // })
      } catch (e) {
        console.log(e)
        this.$router.push({ name: 'v1-settings' }).catch(() => {})
        // this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },

    openConfirm (id) {
      this.deleted_id = id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this field? This will delete all your data related to this field',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.deleteattribue(this.deleted_id)
    },

    // delete_columns (id) {

    //   this.deleteattribue(id)
    // },
    async deleteattribue (id) {
      this.$vs.loading({
        // type:type,
      })
      this.load_delete = true
      const payload = {
        attribute_id: id
      }

      try {
        const { data } = await deleteCustomField(payload)
        this.$vs.loading.close()

        this.$vs.notify({
          title: 'Success',
          text: 'Dynamic Field Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        // const index = this.custom_fields.indexOf(id)
        let deleted_id = 0
        const fields_lists = this.custom_fields
        for (let i = 0; i < fields_lists.length; i++) {
          if (fields_lists[i].attribute_id === id) {
            deleted_id = i
          }
        }
        fields_lists.splice(deleted_id, 1)
        this.custom_fields = fields_lists
      } catch (e) {
        this.$vs.loading.close()
      }
    }
  }
}
</script>

<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}

/* .vs-sidebar .vs-sidebar--items{
    overflow-y: scroll !important;
  } */

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}

.con-vs-dropdown--menu {
  z-index: 100001;
}
</style>
